<template>
    <el-table
        v-loading="isLoading"
        :data="data"
        class="row-click ah-el-data-table salary-page-bonus-table"
        show-summary
        :summary-method="getSummaries"
        @row-click="$event => $emit('row-click', $event)"
        border
    >
        <el-table-column prop="month" label="所屬月份" sortable width="130">
            <template slot-scope="scope">
                <span class="strong"> {{ scope.row.year }} 年 {{ scope.row.month }} 月 </span>
            </template>
        </el-table-column>
        <el-table-column prop="headcount" label="人數" width="70" align="right" type="headcount">
            <template slot-scope="scope">
                <Money :v="scope.row.headcount" />
            </template>
        </el-table-column>
        <el-table-column prop="totaL_AMT2" label="績效" sortable align="right">
            <template slot-scope="scope">
                <Money :v="scope.row.totaL_AMT2" />
            </template>
        </el-table-column>
        <el-table-column prop="totaL_AMT" label="獎金" sortable align="right">
            <template slot-scope="scope">
                <Money :v="scope.row.totaL_AMT" />
            </template>
        </el-table-column>
        <el-table-column prop="withholdingEls" label="代扣稅款" sortable align="right" width="130">
            <template slot-scope="scope">
                <Money :v="scope.row.withholdingEls" />
            </template>
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholdingEls" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <span>
                            {{ scope.row.withholdingElsPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
            <!-- <el-table-column
                prop="withholdingTaxPaymentDate"
                label="日期"
                sortable
                align="right"
                width="130"
                type="date"
            >
                <template slot-scope="scope">
                    <span style="font-weight: bold">
                        {{ scope.row.withholdingTaxPaymentDate | dateFormater("YYYY-MM-dd") }}
                    </span>
                </template>
            </el-table-column> -->
        </el-table-column>
        <el-table-column prop="withholding2ndHealth" label="代扣二代健保" sortable align="right" width="130">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholding2ndHealth" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <span>
                            {{ scope.row.withholding2ndHealthPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
            <!-- <el-table-column
                prop="withholding2ndHealthPaymentDate"
                label="日期"
                sortable
                align="right"
                width="130"
                type="date"
            >
                <template slot-scope="scope">
                    <span style="font-weight: bold">
                        {{ scope.row.withholding2ndHealthPaymentDate | dateFormater("YYYY-MM-dd") }}
                    </span>
                </template>
            </el-table-column> -->
        </el-table-column>
        <el-table-column prop="amt" label="實付" sortable align="right">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.amt" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <span>
                            {{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <!-- <el-table-column label="付款日期" sortable align="right" width="130" type="date">
            <template slot-scope="scope">
                <span style="font-weight: bold">
                    {{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}
                </span>
            </template>
        </el-table-column> -->
    </el-table>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '總計';
                    return;
                }
                if (column.type === 'date' || column.type === 'headcount') {
                    // 付款日期、人數
                    return;
                }

                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => Number.isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!Number.isNaN(value)) {
                            return prev + curr;
                        }
                        return prev;
                    }, 0);
                    sums[index] += '';
                } else {
                    sums[index] = 'N/A';
                }
                if (index !== 0) {
                    if (!Number.isNaN(sums[index])) {
                        sums[index] = Number.parseInt(sums[index], 10).toLocaleString('en-US');
                    }
                }
            });

            return sums;
        },
    },
};
</script>
<style lang="scss">
.salary-page-bonus-table {
    .el-table__header-wrapper tbody td,
    .el-table__footer-wrapper tbody td {
        // background-color: #fff;
        // border-top: 1px solid #ccc;
        font-weight: bold;
    }
}
</style>
